import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack900Base, colorCoreGray100 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
import { onOpenWindow } from '@yme/utils/common';
import { BLANK } from '@yme/utils/constants';
import { ButtonTeaserLinkStyled, StyledFlexWrapper, TeaserContainerStyled } from './';
export function MyYamahaTeaser(props) {
    const isRightToLeft = useSelector(getRTL);
    const { imagePath, linkUrl, actions, actionsEnabled, title, description } = props;
    const handleClick = useCallback(() => {
        if (linkUrl && !actionsEnabled) {
            onOpenWindow(linkUrl, BLANK);
        }
    }, [actionsEnabled, linkUrl]);
    const textColor = imagePath ? colorCoreGray100 : colorCoreBlack900Base;
    return (React.createElement(TeaserContainerStyled, { flexDirection: "column", alignItems: "center", onClick: handleClick, imagePath: imagePath, linkUrl: linkUrl },
        React.createElement(StyledFlexWrapper, null,
            React.createElement(FlexWrapper, { flexDirection: "column", gap: "20px" },
                React.createElement(HeadingLevel2, { color: textColor }, title),
                React.createElement(RegularTextLevel3, { color: textColor }, description)),
            actionsEnabled && (React.createElement(FlexWrapper, { gap: "20px" }, actions?.map((action) => {
                return (React.createElement(ButtonTeaserLinkStyled, { key: action.text, buttonLink: action.link, buttonLabel: action.text, isRightToLeft: isRightToLeft }));
            }))))));
}
MyYamahaTeaser.displayName = 'MyYamahaTeaser_AEMComponent';
